var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("footer", { staticClass: "footer", attrs: { id: "store-footer" } }, [
        _c("div", [
          _c("div", { staticClass: "footer-body" }, [
            _c("div", { staticClass: "columns is-centered" }, [
              _vm._m(0),
              _vm._v(" "),
              _vm._m(1),
              _vm._v(" "),
              _vm._m(2),
              _vm._v(" "),
              _c("div", { staticClass: "column" }, [
                _c(
                  "h4",
                  {
                    staticClass: "footer-header is-size-4 has-text-weight-bold"
                  },
                  [_vm._v("NEVER MISS A DEAL!")]
                ),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "Receive special discounts and exclusive offers you won't find anywhere else!"
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "eclub-cta",
                    on: {
                      click: function($event) {
                        return _vm.goToPromotionalOffers()
                      }
                    }
                  },
                  [
                    _c(
                      "BaseButton",
                      { attrs: { classNames: ["square-btn"] } },
                      [
                        _c("BaseIcon", {
                          attrs: {
                            classNames: ["envelope"],
                            icon: "envelope",
                            size: "1x"
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "eclub-cta-join" }, [
                          _vm._v("JOIN ECLUB!")
                        ])
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { attrs: { id: "social-section" } }, [
                  _c(
                    "h4",
                    {
                      staticClass:
                        "footer-header is-size-4 has-text-weight-bold"
                    },
                    [_vm._v("CONNECT WITH US!")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "social-icon-container" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://www.facebook.com/realpizzarealvalue",
                          "aria-label": "Pizza Guys on Facebook",
                          target: "_blank",
                          rel: "noopener"
                        }
                      },
                      [
                        _c("BaseIcon", {
                          attrs: {
                            classNames: ["social-icon"],
                            icon: "facebook",
                            size: "2x"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://www.instagram.com/pizzaguysofficial/",
                          "aria-label": "Pizza Guys on Instagram",
                          target: "_blank",
                          rel: "noopener"
                        }
                      },
                      [
                        _c("BaseIcon", {
                          attrs: {
                            classNames: ["social-icon"],
                            icon: "instagram",
                            size: "2x"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://www.linkedin.com/company/1805106",
                          "aria-label": "Pizza Guys on LinkedIn",
                          target: "_blank",
                          rel: "noopener"
                        }
                      },
                      [
                        _c("BaseIcon", {
                          attrs: {
                            classNames: ["social-icon"],
                            icon: "linkedIn",
                            size: "2x"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://twitter.com/PizzaGuys",
                          "aria-label": "Pizza Guys on Twitter",
                          target: "_blank",
                          rel: "noopener"
                        }
                      },
                      [
                        _c("BaseIcon", {
                          attrs: {
                            classNames: ["social-icon"],
                            icon: "twitter",
                            size: "2x"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://www.pinterest.com/pizzaguys/",
                          "aria-label": "Pizza Guys on Pinterest",
                          target: "_blank",
                          rel: "noopener"
                        }
                      },
                      [
                        _c("BaseIcon", {
                          attrs: {
                            classNames: ["social-icon"],
                            icon: "pinterest",
                            size: "2x"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "columns is-centered copyright-section" },
              [
                _c("div", { staticClass: "column" }, [
                  _c("p", { staticClass: "has-text-centered is-size-7" }, [
                    _vm._v("Copyright © " + _vm._s(_vm.currentYear) + " "),
                    _vm.franchisor && _vm.franchisor.paymentLoyaltyFlowModel
                      ? _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.franchisor.paymentLoyaltyFlowModel
                                .localMarketingName
                            )
                          )
                        ])
                      : _vm._e(),
                    _vm._v(
                      "\n\t\t\t\t\t\t\tFranchises, Inc. All Rights Reserved."
                    )
                  ])
                ])
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("tp-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-hidden-mobile" }, [
      _c("img", {
        attrs: {
          id: "footer-logo",
          src: require("@/assets/footer/footer-logo.png"),
          alt: "footer logo"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column" }, [
      _c(
        "h4",
        { staticClass: "footer-header is-size-4 has-text-weight-bold" },
        [_vm._v("FRANCHISING")]
      ),
      _vm._v(" "),
      _c("ul", { staticClass: "menu", attrs: { id: "menu-franchising" } }, [
        _c(
          "li",
          {
            staticClass:
              "menu-item menu-item-type-post_type menu-item-object-page menu-item-11828",
            attrs: { id: "menu-item-11828" }
          },
          [
            _c(
              "a",
              {
                attrs: {
                  rel: "noopener",
                  href: "https://www.pizzaguys.com/franchising/our-brand/"
                }
              },
              [_vm._v("Our\n\t\t\t\t\t\t\t\t\tBrand")]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            staticClass:
              "menu-item menu-item-type-post_type menu-item-object-page menu-item-11824",
            attrs: { id: "menu-item-11824" }
          },
          [
            _c(
              "a",
              {
                attrs: {
                  rel: "noopener",
                  href: "https://www.pizzaguys.com/franchising/our-leadership/"
                }
              },
              [_vm._v("Our\n\t\t\t\t\t\t\t\t\tLeadership")]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            staticClass:
              "menu-item menu-item-type-post_type menu-item-object-page menu-item-11977",
            attrs: { id: "menu-item-11977" }
          },
          [
            _c(
              "a",
              {
                attrs: {
                  rel: "noopener",
                  href:
                    "https://www.pizzaguys.com/franchising/franchise-process/"
                }
              },
              [_vm._v("Franchise\n\t\t\t\t\t\t\t\t\tProcess")]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            staticClass:
              "menu-item menu-item-type-post_type menu-item-object-page menu-item-11982",
            attrs: { id: "menu-item-11982" }
          },
          [
            _c(
              "a",
              {
                attrs: {
                  rel: "noopener",
                  href: "https://www.pizzaguys.com/franchising/investment/"
                }
              },
              [_vm._v("Investment")]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            staticClass:
              "menu-item menu-item-type-post_type menu-item-object-page menu-item-12209",
            attrs: { id: "menu-item-12209" }
          },
          [
            _c(
              "a",
              {
                attrs: {
                  rel: "noopener",
                  href:
                    "https://www.pizzaguys.com/franchising/franchisee-support/"
                }
              },
              [_vm._v("Franchisee\n\t\t\t\t\t\t\t\t\tSupport")]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            staticClass:
              "menu-item menu-item-type-post_type menu-item-object-page menu-item-11826",
            attrs: { id: "menu-item-11826" }
          },
          [
            _c(
              "a",
              {
                attrs: {
                  rel: "noopener",
                  href:
                    "https://www.pizzaguys.com/franchising/available-locations/"
                }
              },
              [_vm._v("Available\n\t\t\t\t\t\t\t\t\tLocations")]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            staticClass:
              "menu-item menu-item-type-post_type menu-item-object-page menu-item-11825",
            attrs: { id: "menu-item-11825" }
          },
          [
            _c(
              "a",
              {
                attrs: {
                  rel: "noopener",
                  href:
                    "https://www.pizzaguys.com/franchising/franchisee-application/"
                }
              },
              [_vm._v("Franchisee\n\t\t\t\t\t\t\t\t\tApplication")]
            )
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column" }, [
      _c(
        "h4",
        { staticClass: "footer-header is-size-4 has-text-weight-bold" },
        [_vm._v("ABOUT US")]
      ),
      _vm._v(" "),
      _c("ul", { staticClass: "menu", attrs: { id: "menu-about-us" } }, [
        _c(
          "li",
          {
            staticClass:
              "menu-item menu-item-type-post_type menu-item-object-page menu-item-11811",
            attrs: { id: "menu-item-11811" }
          },
          [
            _c(
              "a",
              {
                attrs: {
                  rel: "noopener",
                  href: "https://www.pizzaguys.com/about/our-history/"
                }
              },
              [_vm._v("Our\n\t\t\t\t\t\t\t\t\tHistory")]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            staticClass:
              "menu-item menu-item-type-post_type menu-item-object-page menu-item-11810",
            attrs: { id: "menu-item-11810" }
          },
          [
            _c(
              "a",
              {
                attrs: {
                  rel: "noopener",
                  href: "https://www.pizzaguys.com/about/careers/"
                }
              },
              [_vm._v("Careers")]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            staticClass:
              "menu-item menu-item-type-custom menu-item-object-custom menu-item-11800",
            attrs: { id: "menu-item-11800" }
          },
          [
            _c(
              "a",
              {
                attrs: {
                  rel: "noopener",
                  href: "/nutritional-information/speciality-pizzas"
                }
              },
              [_vm._v("Nutrition")]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            staticClass:
              "menu-item menu-item-type-post_type menu-item-object-page menu-item-12877",
            attrs: { id: "menu-item-12877" }
          },
          [
            _c(
              "a",
              {
                attrs: {
                  rel: "noopener",
                  href: "https://www.pizzaguys.com/faq"
                }
              },
              [_vm._v("FAQ")]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            staticClass:
              "menu-item menu-item-type-post_type menu-item-object-page menu-item-12186",
            attrs: { id: "menu-item-12186" }
          },
          [
            _c(
              "a",
              {
                attrs: {
                  rel: "noopener",
                  href: "https://www.pizzaguys.com/about/press/"
                }
              },
              [_vm._v("Press")]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            staticClass:
              "menu-item menu-item-type-custom menu-item-object-custom menu-item-12605",
            attrs: { id: "menu-item-12605" }
          },
          [
            _c(
              "a",
              {
                attrs: {
                  target: "_blank",
                  rel: "noopener",
                  href: "https://mgd.mercury-gift.com/pizzaguys/Index"
                }
              },
              [_vm._v("Gift Card Balance")]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            staticClass:
              "menu-item menu-item-type-post_type menu-item-object-page menu-item-12187",
            attrs: { id: "menu-item-12187" }
          },
          [
            _c(
              "a",
              {
                attrs: {
                  rel: "noopener",
                  href: "https://www.pizzaguys.com/contact-us"
                }
              },
              [_vm._v("Contact")]
            )
          ]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6d08a398", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d08a398","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer/AppFooter.vue
// module id = null
// module chunks = 